/**
 * Jessie's Home — PDP sale countdown bar (.jh-cd, "C1" design)
 * Ticks every second (shared timer): d/h/m/s digits + progress fill = time
 * remaining over the event, (end - now) / (end - start): 100% → 0%.
 * At the end the bar stays visible (sale prices may be live until the JH-App cron
 * syncs): "A few minutes left..." label, 00 cells, empty bar (.jh-cd--ended), and
 * the element leaves the shared timer. Shows/hides on variant change.
 * Markup + initial values are pre-rendered by snippets/jh-sale-countdown.liquid.
 * Keeps one row on narrow screens: if the full label would be cut off next to
 * the timer, switches to the short "Ends in" label (.jh-cd--short).
 */
(function () {
  'use strict';

  if (window.__jhCountdown) return;
  window.__jhCountdown = true;

  var instances = []; // ticking
  var instancesAll = []; // incl. ended (still follow variant changes)
  var timer = null;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  // "2026-10-31T23:59:59-04:00" → ms. Liquid emits ±HH:MM; ±HHMM (rejected by
  // older Safari) and Z are normalized/accepted too.
  function parseIso(iso) {
    var m = String(iso || '').match(/^(.+?)(Z|([+-])(\d{2}):?(\d{2}))$/);
    if (!m) return null;
    var ms = Date.parse(m[2] === 'Z' ? iso : m[1] + m[3] + m[4] + ':' + m[5]);
    return isNaN(ms) ? null : ms;
  }

  function setText(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }

  function init(el) {
    if (el.__jhCd) return;
    var startMs = parseIso(el.getAttribute('data-start'));
    var endMs = parseIso(el.getAttribute('data-end'));
    if (startMs == null || endMs == null) return;

    var inst = {
      el: el,
      startMs: startMs,
      endMs: endMs,
      expired: el.classList.contains('jh-cd--ended'),
      eligible: !el.hidden,
      ids: (el.getAttribute('data-variants') || '').split(',').filter(Boolean),
      d: el.querySelector('[data-u="d"]'),
      h: el.querySelector('[data-u="h"]'),
      m: el.querySelector('[data-u="m"]'),
      s: el.querySelector('[data-u="s"]'),
      fill: el.querySelector('.jh-cd__fill'),
      full: el.querySelector('.jh-cd__text--full'),
      endText: el.querySelector('.jh-cd__text--end'),
    };
    el.__jhCd = inst;
    instancesAll.push(inst);
    if (inst.expired) {
      end(inst); // pre-rendered zero state: nothing to tick
    } else {
      instances.push(inst);
      tick(inst);
    }
    fit(inst);
    if (typeof ResizeObserver === 'function') {
      // The bar's width doesn't depend on the label, so toggling a class can't loop.
      new ResizeObserver(function () {
        fit(inst);
      }).observe(el);
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        fit(inst);
      });
    }
  }

  function overflows(node) {
    return !!node && node.scrollWidth > node.clientWidth + 1;
  }

  // Short label only when the full one doesn't fit (measured, so any event name works).
  // Zero state: if "A few minutes left..." doesn't fit next to the 00 cells (≈320px
  // phones), drop the "00d" cell instead (.jh-cd--tight) to keep one untruncated row.
  function fit(inst) {
    var el = inst.el;
    if (el.hidden) return;
    if (inst.expired) {
      el.classList.remove('jh-cd--tight');
      if (overflows(inst.endText)) el.classList.add('jh-cd--tight');
      return;
    }
    if (!inst.full) return;
    el.classList.remove('jh-cd--short');
    if (overflows(inst.full)) el.classList.add('jh-cd--short');
  }

  function sync(inst) {
    var hide = !inst.eligible;
    if (inst.el.hidden !== hide) {
      inst.el.hidden = hide;
      if (!hide) fit(inst);
    }
  }

  function setFill(inst, pct) {
    if (!inst.fill) return;
    var width = Math.min(100, Math.max(0, pct)).toFixed(1) + '%';
    if (inst.fill.style.width !== width) inst.fill.style.width = width;
  }

  // Zero state: keep the block, swap the label, 00 cells, empty bar.
  function end(inst) {
    inst.expired = true;
    inst.el.classList.remove('jh-cd--short');
    inst.el.classList.add('jh-cd--ended');
    setText(inst.d, '00');
    setText(inst.h, '00');
    setText(inst.m, '00');
    setText(inst.s, '00');
    setFill(inst, 0);
    fit(inst);
  }

  function tick(inst) {
    var now = Date.now();
    var left = Math.floor((inst.endMs - now) / 1000);
    if (left <= 0) {
      end(inst);
      return;
    }
    setText(inst.d, pad(Math.floor(left / 86400)));
    setText(inst.h, pad(Math.floor((left % 86400) / 3600)));
    setText(inst.m, pad(Math.floor((left % 3600) / 60)));
    setText(inst.s, pad(left % 60));

    var span = inst.endMs - inst.startMs;
    setFill(inst, span > 0 ? ((inst.endMs - now) / span) * 100 : 0);
  }

  function tickAll() {
    instances = instances.filter(function (inst) {
      if (!inst.el.isConnected || inst.expired) return false;
      tick(inst);
      return !inst.expired;
    });
    if (!instances.length && timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function onVariant(variant) {
    if (!variant || variant.id == null) return;
    var id = String(variant.id);
    instancesAll = instancesAll.filter(function (inst) {
      return inst.el.isConnected;
    });
    instancesAll.forEach(function (inst) {
      inst.eligible = inst.ids.indexOf(id) !== -1;
      sync(inst);
    });
  }

  function boot() {
    document.querySelectorAll('[data-jh-cd]').forEach(init);
    if (instances.length && !timer) timer = setInterval(tickAll, 1000);
  }

  // Dawn pub/sub (product-info.js) + the theme's custom jh:variant-change event.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      onVariant(event && event.data && event.data.variant);
    });
  }
  document.addEventListener('jh:variant-change', function (e) {
    var detail = e && e.detail;
    onVariant(detail && (detail.variant || detail));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
